import React, { useEffect } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import hering_img from "../../../img/hearing-exam.jpg";
import hering_img2 from "../../../img/ear-measurements.jpg";
import hering_img3 from "../../../img/Hearing-Implants.jpg";
import hering_img4 from "../../../img/hearing-aids-Repair.jpg";
import "../Services/Service.css";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';

export default function EarMeasurements() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
        <Helmet>
      <title>Real Ear Measurements | Hearing Aids | The Hearing Centre</title>
        <meta name="description" content="Our audiologists at The Hearing Centre Singapore provide facilities on Real ear measurements to verify the level of hearing aids used by the individuals." />
        <meta property="og:title" content="Real Ear Measurements | Hearing Aids | The Hearing Centre"></meta>
        <meta property="og:description" content="Our audiologists at The Hearing Centre Singapore provide facilities on Real ear measurements to verify the level of hearing aids used by the individuals."></meta>
    </Helmet>
      <Header />
      <section className="hearing_service">
        <div className="container">
          <h1 className="Heading_text">Real-Ear Measurement</h1>
        </div>
      </section>

      <section className="Singapore">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6  col-md-12">
              <div className="service_img">
                <img src={hering_img2} className="img-fluid" />
              </div>
            </div>
            <div className="col-xl-6  col-md-12">
              <div className="Sing_text">
                <h5>Real-Ear Measurements</h5>
                <h1>Hearing Aid Services in Singapore</h1>
                <p>
                  Our audiologists at The Hearing Centre provide facilities on
                  ear measurements to verify the level of hearing aids used by
                  the individuals. This test enables our audiologists to
                  overcome the differences being delivered by the hearing aids
                  to the individual’s eardrum.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Other Services */}
      <section className="Other_Services">
        <div className="container">
          <h1 className="Heading_text">Other Services</h1>
          <div className="row">
            <div className="col-md-4">
              <div class="card">
                <img src={hering_img} class="card-img-top" alt="..." />
                <div class="card-body">
                  <Link className="" to="">
                    <h5 class="card-title">Hearing Tests</h5>
                  </Link>
                  <p class="card-text">
                    At The Hearing Centre, we work closely with individuals to
                    help them understand the type and degree of hearing problems
                    they have and become a companion with them on the path
                    towards better hearing.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div class="card">
                <img src={hering_img3} class="card-img-top" alt="..." />
                <div class="card-body">
                  <Link className="" to="">
                    <h5 class="card-title">Hearing Implants</h5>
                  </Link>

                  <p class="card-text">
                    Hearing implants, or Cochlear implants are small complex
                    devices that enable individuals with hearing losses to hear
                    the sounds around them.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div class="card">
                <img src={hering_img4} class="card-img-top" alt="..." />
                <div class="card-body">
                  <Link className="" to="">
                    <h5 class="card-title">Repairs & Adjustments</h5>
                  </Link>
                  <p class="card-text">
                    At The Hearing Centre, we take utmost care of your hearing
                    aids whether they have worn out or been exposed to any
                    external environmental factor, physical damage or excessive
                    wax.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
